module.exports = __webpack_public_path__ + "static/media/spanish version Training Manual June 25 2012 Final.f040950e.ea014c31.pdf";